var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxIdeaOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9691 7.81909C14.9752 6.92935 14.7431 6.05418 14.2969 5.28444C13.8506 4.5147 13.2063 3.87845 12.4311 3.44175C11.6559 3.00504 10.7779 2.78379 9.88834 2.80098C8.99874 2.81816 8.12996 3.07315 7.37219 3.53948C6.61441 4.00579 5.99528 4.66645 5.57904 5.45285C5.16282 6.23926 4.96466 7.12273 5.00517 8.01157C5.04567 8.90041 5.32334 9.7622 5.80938 10.5075C6.29541 11.2528 6.97207 11.8544 7.76911 12.2499V13.9114C7.76911 14.0583 7.82746 14.1992 7.93133 14.303C8.0352 14.4069 8.17607 14.4653 8.32295 14.4653H11.646C11.7929 14.4653 11.9338 14.4069 12.0377 14.303C12.1415 14.1992 12.1999 14.0583 12.1999 13.9114V12.2499C13.0279 11.8419 13.7256 11.2112 14.2149 10.4284C14.704 9.64573 14.9652 8.74209 14.9691 7.81909Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77148 17.2H12.2023",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxIdeaOutline);
export default __webpack_public_path__ + "static/media/icon_20px_idea-outline.ca5d87493b0698112b4715016ea45f29.svg";
export { ForwardRef as ReactComponent };